export default {
    "alerts": {
        "alerts": "Alarme",
        "createAlert": "Alarm erstellen",
        "manageAlerts": "Alarme verwalten",
        "alertAlreadyExists": "Ein Alarm mit diesem Namen existiert bereits. Möchten Sie ihn ersetzen?"
    },

    "editAlert": {
        "title": "Alarm",
        "name": "Name",
        "frequency": "Häufigkeit",
        "days": "Tage",
        "monday": "Montag",
        "tuesday": "Dienstag",
        "wednesday": "Mittwoch",
        "thursday": "Donnerstag",
        "friday": "Freitag",
        "saturday": "Samstag",
        "sunday": "Sonntag",
        "times": "Uhrzeitangaben",
        "active": "Aktiv",
        "updateQuery": "Aktualisiere Suchanfrage",
        "runQuery": "Führe Suchanfrage aus",
        "lossDataMessage": "Möchten Sie gehen, ohne Ihre Änderungen zu speichern?"
    },

    "manageAlerts": {
        "title": "Alarme verwalten",
        "edit": "Bearbeiten",
        "reorder": "Neu sortieren",
        "remove": "Entfernen",
        "removeAll": "Alle entfernen"
    },

};
